import React, { useState } from 'react';
import { evaluate, appendToken, applyUnary, backspace } from './calculatorEngine';
import './basicCalculator.css';

const KEYS = [
  ['C', '(', ')', '⌫'],
  ['√', 'x²', '%', '±'],
  ['7', '8', '9', '/'],
  ['4', '5', '6', '*'],
  ['1', '2', '3', '-'],
  ['0', '.', '=', '+'],
];

const UNARY = { '√': 'sqrt', 'x²': 'square', '%': 'percent', '±': 'negate' };

export default function BasicCalculator() {
  const [expr, setExpr] = useState('');
  const [display, setDisplay] = useState('0');

  const handle = (key) => {
    if (key === 'C') { setExpr(''); setDisplay('0'); return; }
    if (key === '⌫') { const e = backspace(expr); setExpr(e); setDisplay(e || '0'); return; }
    if (key === '=') { const r = evaluate(expr); setDisplay(String(r)); setExpr(r === 'Error' ? '' : String(r)); return; }
    if (UNARY[key]) { const e = applyUnary(expr, UNARY[key]); setExpr(e); setDisplay(e || '0'); return; }
    const e = appendToken(expr, key);
    setExpr(e); setDisplay(e || '0');
  };

  return (
    <div className="basicCalc">
      <div className="basicCalcDisplay" data-testid="calc-display">{display}</div>
      <div className="basicCalcKeys">
        {KEYS.flat().map((k) => (
          <button
            key={k}
            className={`basicCalcKey ${['/', '*', '-', '+', '='].includes(k) ? 'op' : ''}`}
            onClick={() => handle(k)}
          >
            {k}
          </button>
        ))}
      </div>
    </div>
  );
}
